import { render, staticRenderFns } from "./RatingSearch.vue?vue&type=template&id=56dedc6c&scoped=true&"
import script from "./RatingSearch.vue?vue&type=script&lang=js&"
export * from "./RatingSearch.vue?vue&type=script&lang=js&"
import style0 from "./RatingSearch.vue?vue&type=style&index=0&id=56dedc6c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56dedc6c",
  null
  
)

export default component.exports